import '../../styles/Footer.css'

function Footer() {

    return (
        <footer id='footer'>
            <div className='icons-footer-container'>
                <div>
                <a href="https://github.com/Rean18" target='_blank' rel="noopener noreferrer">
                    <img src="/assets/icons/github-footer.png" alt="icône de GitHub" />
                </a>
                </div>
               <div>
               <a href="https://linkedin.com/in/remi-pinheiro" target='_blank' rel="noopener noreferrer">
                    <img src="/assets/icons/linkedin-brands.png" alt="icône de Linkedin" />
                </a>
               </div>
               
                
            </div>
            <div className='mentions-container'>
                <p>Tous droits réservés</p>
            </div>
        </footer>
    )
}

export default Footer;